import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import store from '../store';
import pages from "../api/pages";

Vue.use(Router);
const router = new Router({
  base: '/',
  mode: 'history',
  linkActiveClass: 'active',
  routes: paths,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      // Иначе скроллим наверх
      return { x: 0, y: 0 };
    }
  }
});

export default router;
